// firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

export const getFirebaseConfig = () => ({
  apiKey: "AIzaSyBgMq6sD8H4rx4CGkYWzvPhB63bGpYHrQM",
  authDomain: "flooron.firebaseapp.com",
  projectId: "flooron",
  storageBucket: "flooron.firebasestorage.app",
  messagingSenderId: "100493076226",
  appId: "1:100493076226:web:44bc1e7db4b1aa4fdd441b",
  measurementId: "G-X0E6BZ4Q8K",
});

// Lazy initialization
let app: ReturnType<typeof initializeApp> | null = null;
export const getFirebaseApp = () => {
  if (!app) {
    app = initializeApp(getFirebaseConfig());
  }
  return app;
};

export const auth = getAuth(getFirebaseApp());
